export default "__VITE_ASSET__D_v5apjQ__"